
import { Component, Vue } from 'vue-property-decorator';
import { ICancellableResult, isCallValidAndNotCancelled } from '@t/ajax-wrapper';
import { IBootstrapTableColumn } from '@/entity/shared/bootstrap';
import { NU } from '@t/type';
import { vxm } from '@/store';
import { IEmployeeRole, IReferential } from '@/entity/shared/referential';
import { referentialApi } from '@/wapi/referential-api';
import CurrencyInput from '@c/shared/currency-input.vue';
import frenchLocale from 'date-fns/locale/fr';
import { format } from 'date-fns';

@Component({
    components: {
        CurrencyInput
    }
})
export default class ReferentialEmployeeRole extends Vue {
    insuranceTypes : NU<IReferential[]> = [];
    private promiseExport: boolean = false;
    private isBusy: boolean = true;

   
    get isValidForm(): boolean {
        let res = true;
        this.insuranceTypes?.forEach((element) => {
            res = res && element.code !== undefined && element.code.length === 3;
            res = res && element.label !== undefined && element.label !== '';
        });
        return res;
    }

    async getInsuranceTypes(): Promise<void> {
        const insuranceTypesCallData = await referentialApi.getAllInsuranceTypes();
        if (isCallValidAndNotCancelled<IReferential[]>(insuranceTypesCallData)) {
            if (insuranceTypesCallData?.datas) {
                this.insuranceTypes = insuranceTypesCallData.datas;
            }
        }
    }

    private fields: Array<IBootstrapTableColumn | string> = [
        { label: 'Code', key: 'code', thStyle: 'width:200px' },
        { label: 'Description', key: 'label' },
        { label: 'Taux', key: 'rate' },
        { label: '', key: 'delete', thStyle: 'width:80px' }
    ];

    async saveInsuranceTypes(): Promise<void> {
        const callData = await referentialApi.patchInsuranceTypes(this.insuranceTypes ?? []);
        if (isCallValidAndNotCancelled(callData)) {
            this.getInsuranceTypes();
            this.$bvToast.toast('Enregistrement effectué avec succès', {
                title: "Liste des types d'assurance",
                variant: 'success',
                solid: true
            });
        }
    }

    addInsuranceTypes(): void {
        const insuranceTypes = {} as IReferential;
        this.insuranceTypes?.push(insuranceTypes);
    }

    deleteInsuranceTypesLine(item: IEmployeeRole): void {
        const index = this.insuranceTypes?.indexOf(item);
        if (index !== undefined && index > -1) {
            this.insuranceTypes?.splice(index, 1);
        }
    }

    formatterCode(val: string): string {
        if (!val) {
            return val;
        }
        return val.toUpperCase().trim().substring(0, 3);
    }

    async exportInsuranceTypes(): Promise<void> {
        await this.generateReport(
            referentialApi.exportInsuranceTypesData(),
            `Liste_des_types_d'assurance"_${this.formatDate(new Date())}.xlsx`
        );
    }

    private formatDate(date: Date): string {
        return format(new Date(String(date)), 'yyyy-MM-dd', { locale: frenchLocale }) ?? '';
    }

    private async generateReport(request: Promise<ICancellableResult<string>>, reportName: string): Promise<void> {
        this.promiseExport = true;
        const response = await request;
        if (response && response.datas) {
            const blob = new Blob([response.datas], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;'
            });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');

            link.href = url;
            link.download = reportName;
            link.click();
            this.promiseExport = false;
        }
        // We wait for the file to download before removing loading state
        setTimeout(() => {
            this.promiseExport = false;
        }, 1000);
    }

    private async mounted() {
        vxm.app.changeTitleMain("Liste des types d'assurance");
        this.getInsuranceTypes();
        this.isBusy = false;
    }
}
